import { render, staticRenderFns } from "./link-textarea-input.vue?vue&type=template&id=0544657e&"
import script from "./link-textarea-input.vue?vue&type=script&lang=js&"
export * from "./link-textarea-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports